import { ZonedDateTimeFactory, ZonedDateTimeFormatter, zonedStartOfDay } from '@csp/csp-common-date-util';
import {
  ApiOptions,
  CloseoutTrackerStatusType,
  IsoDateStr,
  OrgId,
  StateAssert,
  StudyOrg,
  StudyOrgStatusType,
} from '@csp/csp-common-model';
import { OrgType } from '@csp/dmdp-api-org-dto';
import { StudyOrgMapper } from '../mapper/StudyOrgMapper';
import { OrgService } from './OrgService';

const updateCloseoutPeriodStatus = async (studyOrgId: OrgId, pacdValue: IsoDateStr): Promise<void> => {
  const zonedPacdValue = ZonedDateTimeFactory.fromZonedDateTimeString(pacdValue);

  StateAssert.notNull(zonedPacdValue, `Provided an invalid pacd date: ${pacdValue}`);

  const zonedStartOfDayPacdValue = zonedStartOfDay(zonedPacdValue);

  await OrgService.upsertCustomStatus(studyOrgId, {
    type: StudyOrgStatusType.STUDY_CLOSE_OUT_PERIOD,
    value: CloseoutTrackerStatusType.ACTIVE,
    localTimestamp: ZonedDateTimeFormatter.toZonedDateTimeString(zonedStartOfDayPacdValue),
  });
};

const getStudyOrg = async (apiOptions?: ApiOptions): Promise<StudyOrg> => {
  const studyOrgs = await OrgService.fetchAllByTypes([OrgType.TREE, OrgType.COUNTRY, OrgType.PRACTICE], apiOptions);
  return StudyOrgMapper.fromOrgs(studyOrgs);
};

export const StudyOrgService = {
  updateCloseoutPeriodStatus,
  getStudyOrg,
};
